import { generateRoutes } from 'utils/generateRoutes';

export const forgotPasswordRoutes = generateRoutes(
  {
    recover: 'recover',
    checkInbox: 'check-inbox',
  },
  'forgot-password'
);
